<div class="fullcontainer">
  <div class='row titleContainer mb-3'>
    <div class="col">
      <h2 class='header' style='color: #006498'>All Opportunities</h2>
    </div>
    <div class='col-2 text-right'>
      <button class='btn btn-secondary' routerLink='/opportunities/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>

  <div class="row">
    <div class="col">
      <app-grid
        entity='opportunity'
        [filters]='this.filters'
        [columns]='this.columns'
        [buttons]='this.buttons'
        [searchFilters]='this.searchFilters'
        [searchFields]='this.searchFields'
    ></app-grid>
    </div>
  </div>
